/** CHECK-constrained company_role_type values (programs.company_role_type). */ export const COMPANY_ROLE_TYPE_OPTIONS = [
    {
        value: 'PRIME',
        label: 'Prime'
    },
    {
        value: 'SUB',
        label: 'Subcontractor'
    },
    {
        value: 'JV_LEAD',
        label: 'JV Lead'
    },
    {
        value: 'JV_MEMBER',
        label: 'JV Member'
    },
    {
        value: 'TEAMING',
        label: 'Teaming'
    }
];
const labelByValue = new Map(COMPANY_ROLE_TYPE_OPTIONS.map((o)=>[
        o.value,
        o.label
    ]));
export function companyRoleLabel(value) {
    if (!value) return '—';
    return labelByValue.get(value) ?? value;
}
